import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { ModuleWithProviders } from '@angular/core';
import { AuthGuard } from '../../_guards';
import { CheckAccessibility } from '../../shared/utils/permission';
import { LayoutModule } from '@angular/cdk/layout';

export const routes: Routes = [
  {
    path: 'app',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: async () =>
          await import('../dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
        canActivate: [CheckAccessibility],
      },
      {
        path: 'cms',
        loadChildren: async () =>
          await import('../cms/cms.module').then((m) => m.CmsModule),
        canActivate: [CheckAccessibility],
      },
      {
        path: 'kyc',
        loadChildren: async () =>
          await import('../kyc/kyc.module').then((m) => m.KycModule),
        canActivate: [CheckAccessibility],
      },
      {
        path: 'platform-settings',
        loadChildren: async () =>
          await import('../platform-settings/platform-settings.module').then(
            (m) => m.PlatformSettingsModule
          ),
        canActivate: [CheckAccessibility],
      },
      {
        path: 'bonus',
        loadChildren: async () =>
          await import('../bonus/bonus.module').then((m) => m.BonusModule),
        canActivate: [CheckAccessibility],
      },
      {
        path: 'ranking',
        loadChildren: async () =>
          await import('../ranking/ranking.module').then(
            (m) => m.RankingModule
          ),
        canActivate: [CheckAccessibility],
      },
      {
        path: 'approval',
        loadChildren: async () =>
          await import('../ib-mam/ib-mam.module').then((m) => m.IbMamModule),
        canActivate: [CheckAccessibility],
      },
      {
        path: 'user-settings',
        loadChildren: async () =>
          await import('../user-settings/user-settings.module').then(
            (m) => m.UserSettingsModule
          ),
        canActivate: [CheckAccessibility],
      },
      {
        path: 'cms',
        loadChildren: async () =>
          await import('../cms/cms.module').then((m) => m.CmsModule),
        canActivate: [CheckAccessibility],
      },
      {
        path: 'affiliate',
        loadChildren: async () =>
          await import('../affiliate/affiliate.module').then(
            (m) => m.AffiliateModule
          ),
        canActivate: [CheckAccessibility],
      },
      {
        path: 'wallet',
        loadChildren: async () =>
          await import('../wallet/wallet.module').then((m) => m.WalletModule),
        canActivate: [CheckAccessibility],
      },
      {
        path: 'mam-rebate',
        loadChildren: async () =>
          await import('../mam-rebate/mam-rebate.module').then(
            (m) => m.MamRebateModule
          ),
      },
      {
        path: 'email-marketing',
        loadChildren: () => import('../email-marketing/email-marketing.module').then((m) => m.EmailMarketingModule),
      },
      {
        path: 'email-campaigns',
        loadChildren: () => import('../email-history/email-history.module').then((m) => m.EmailHistoryModule),
      },
    ],
  },
];

export const routing: ModuleWithProviders<LayoutModule> =
  RouterModule.forChild(routes);
